export default __webpack_public_path__ + "static/media/f2.286d9efa.jpg";